import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20light%20streaming%20across%20modern%20retail%20boutique%20interior%20with%20stylish%20clothing%20racks%20and%20accessories%20display%2C%20polished%20concrete%20floor%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20sophisticated%20minimalist%20store%20design%2C%20inviting%20shopping%20atmosphere%2C%20soft%20natural%20light%20creating%20gentle%20shadows%2C%20editorial%20interior%20photography%2C%20elegant%20and%20aspirational%20lifestyle%20setting&width=1920&height=900&seq=cta-bg-new-2026&orientation=landscape"
          alt="USFans Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16 max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight" style={{ textShadow: '0 2px 12px rgba(0,0,0,0.3)' }}>
          Odkryj pełny przewodnik USFans Spreadsheet już teraz
        </h2>
        <p className="text-white/75 mt-4 md:mt-6 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
          Nie wiesz od czego zacząć? Przygotowaliśmy kompletną bazę wiedzy o USFans Spreadsheet, dzięki której szybko znajdziesz potrzebne informacje.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Kup teraz
            <div className="w-7 h-7 rounded-full bg-accent-500 flex items-center justify-center -mr-1">
              <i className="ri-shopping-bag-line text-white text-xs"></i>
            </div>
          </a>
          <Link
            to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Przeczytaj przewodnik
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}